module.exports = ":host .jobs-cell-item {\n  margin: 0;\n  height: 100%; }\n"


//////////////////
// WEBPACK FOOTER
// ./web/modern/components/quotes/common/quote-client-info/quote-client-info.scss
// module id = ./web/modern/components/quotes/common/quote-client-info/quote-client-info.scss
// module chunks = 0